import React from 'react';
import { useNavigate } from 'react-router';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';

import constants from '../../config/constants';
import store from '../../config/store';
import UserMenu from './UserMenu';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, sideNavWidth = constants.SIDE_NAV_WIDTH }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: sideNavWidth,
    width: `calc(100% - ${sideNavWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function AppBar({ isSidebarOpen = false, toggleSideNav = () => {} }) {
  const navigate = useNavigate();

  const pageTitle = store.useApp((state) => state.pageTitle);
  const backPath = store.useApp((state) => state.backPath);

  return (
    <StyledAppBar
      color="inherit"
      sx={{ boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.12)' }}
      position="absolute"
      open={isSidebarOpen}
    >
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleSideNav}
          sx={{
            marginRight: '36px',
            ...(isSidebarOpen && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h2"
          variant="h5"
          fontWeight={800}
          color="black"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          {pageTitle}
          {backPath && (
            <Button
              variant="outlined"
              onClick={() => navigate(backPath)}
              size="small"
              sx={{ fontSize: '12px', marginLeft: '6px', padding: '2px 10px' }}
            >
              <ArrowBackIcon sx={{ fontSize: '12px', marginRight: '4px' }} />{' '}
              Back
            </Button>
          )}
        </Typography>
        <UserMenu />
      </Toolbar>
    </StyledAppBar>
  );
}

export default AppBar;
